import $ from 'jquery';

const sidebarScroll = () => {
        var content = $('.js-content');
        var sidebar = $('.js-sidebar-item');

        $(window).on('scroll', function () {

            //現在のスクロール位置を取得
            var currentTop = $(window).scrollTop();

            //各コンテンツに対して、以下の関数を繰り返し実行
            content.each(function () {

                //処理中のコンテンツのdata属性の値を取得
                var contentData = $(this).data('scroll');
                var currentSidebar = sidebar.filter('[data-scroll="' + contentData + '"]');

                //処理中のコンテンツの上端と下端の情報を取得
                var contentTop = $(this).offset().top - 64;
                var contentBottom = $(this).height() + contentTop;

                //スクロール位置が処理中のコンテンツの範囲内にある場合
                if( contentTop <= currentTop && currentTop < contentBottom ) {
                    sidebar.removeClass('current');
                    currentSidebar.addClass('current');
                }
            });
        });
}

const main = () => {
    if (document.querySelector('#page-staff-detail') === null) return;
    sidebarScroll();
}

export default main;
